import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Reveal, Overline } from "./Reveal";

const VALUES = [
  {
    n: "01",
    title: "Un univers doux et féminin",
    text: "Un cocon aux tons roses pensé pour que chaque visite soit une parenthèse. Lumière douce, musique feutrée, parfum délicat : ici, on se pose, on respire, on se laisse chouchouter.",
  },
  {
    n: "02",
    title: "Une hygiène irréprochable",
    text: "Matériel stérilisé, consommables à usage unique, surfaces désinfectées entre chaque cliente. Les protocoles d'hygiène de l'institut sont stricts — votre sécurité n'est jamais une option.",
  },
  {
    n: "03",
    title: "Une attention pour chaque cliente",
    text: "Diagnostic personnalisé, écoute de vos envies, conseils d'entretien adaptés à votre routine. Chaque prestation est un moment sur mesure, jamais du travail à la chaîne.",
  },
];

export default function Manifesto() {
  const [team, setTeam] = useState([]);

  useEffect(() => {
    api.get("/team").then((res) => setTeam(res.data.team)).catch(() => {});
  }, []);

  return (
    <section id="apropos" className="mx-auto max-w-7xl px-6 py-28 lg:px-12 lg:py-40" data-testid="about-section">
      <Reveal>
        <Overline className="mb-6">À propos</Overline>
        <h2 className="font-display max-w-2xl text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[var(--brand-dark)]">
          L'institut, <span className="italic font-light text-[var(--brand-accent)]">son univers.</span>
        </h2>
      </Reveal>

      <div className="mt-20 space-y-24 lg:space-y-28">
        {VALUES.map((v, i) => (
          <Reveal key={v.n} className={`flex flex-col gap-6 md:items-start ${i % 2 ? "md:flex-row-reverse md:text-right" : "md:flex-row"}`}>
            <span className="font-display text-[7rem] sm:text-[9rem] leading-none text-[var(--brand-border)] select-none md:w-1/2 md:shrink-0">
              {v.n}
            </span>
            <div className="md:w-1/2 md:pt-10">
              <h3 className="font-display text-3xl sm:text-4xl text-[var(--brand-dark)] italic font-light">{v.title}</h3>
              <p className="mt-5 max-w-md text-base sm:text-lg font-light leading-relaxed text-[var(--brand-muted)] md:inline-block">{v.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-32">
        <Overline className="mb-6">L'équipe</Overline>
        <h3 className="font-display max-w-xl text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-[var(--brand-dark)]">
          Des expertes <span className="italic font-light text-[var(--brand-accent)]">à votre écoute.</span>
        </h3>
      </Reveal>
      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-testid="team-grid">
        {team.map((m, i) => (
          <Reveal key={m.id} delay={i * 0.1}>
            <div className="group flex h-full flex-col items-center border border-black/5 bg-[var(--brand-section)] p-10 text-center" data-testid={`team-card-${m.id}`}>
              <img src={m.photo} alt={m.name}
                   className="h-28 w-28 rounded-full object-cover ring-4 ring-[var(--brand-border)] transition-transform duration-500 group-hover:scale-105" />
              <h4 className="font-display mt-6 text-2xl text-[var(--brand-dark)]">{m.name}</h4>
              <p className="mt-1 text-xs uppercase tracking-[0.2em] text-[var(--brand-accent)]">{m.role}</p>
              <div className="mt-5 flex flex-wrap justify-center gap-2">
                {m.specialties.map((s) => (
                  <span key={s} className="rounded-full border border-[var(--brand-accent)]/30 px-3 py-1 text-[10px] uppercase tracking-[0.15em] text-[var(--brand-muted)]">
                    {s}
                  </span>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
